import './foundation';
import 'jquery-ui/ui/widgets/datepicker.js';
import ScrollHint from './scroll-hint';

$(function () {
    $.datepicker.setDefaults($.datepicker.regional["ja"]);

    // Page Top
    var appear = false;
    var page_top = $('#page_top');
    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 300) { //100pxスクロールしたら
            if (appear == false) {
                appear = true;
                page_top.stop().animate({
                    'bottom': '16px', //下から50pxの位置に
                    'right': '16px'
                }, 300); //0.3秒かけて現れる
            }
        } else {
            if (appear) {
                appear = false;
                page_top.stop().animate({
                    'bottom': '-50px', //下から-50pxの位置に
                    'right': '0'
                }, 300); //0.3秒かけて隠れる
            }
        }
    });

    page_top.on('click', function () {
        $('body, html').animate({
            scrollTop: 0
        }, 500); //0.5秒かけてトップへ戻る
        return false;
    });

    /**
     * FOUC対策：CSSの最後でローディング時のチラつき防止に #wrapper を非表示に
     * しているので、ロード完了時に表示する
     */
    $('#loading').fadeOut(50);
    $('#wrapper').addClass('loaded');

    /**
     * 横スクロール
     */
    new ScrollHint('.js-scrollable', {
        i18n: {
            scrollable: '横スクロール'
        }
    })
});